module.exports = __webpack_public_path__ + "static/img/cctMerchant.aa7ef41e.png";